<template>
  <div class="justify-content-center text-left mt-5 dp02 p-5">
    <div class="col-lg-12">
      <b-button type="submit"
                class="myButton"
                @click="$router.go(-1)"
                style="float:left">
        {{ $t('common.Back') }}
      </b-button>

      <b-button type="submit"
                class="myButton"
                @click="$router.push({ name: 'admin.producttypes.edit', params: { id:id } });"
                style="float:right">
        {{ $t('common.Edit') }}
      </b-button>
    </div>
    <div v-if="!ready"
         class="row mt-5">
      <b-spinner variant="primary"
                 type="grow"
                 label="Spinning" />
      <span>{{ $t('DataTable.Loading') }}...</span>
    </div>
    <div v-else
         class="row col-lg-12 mt-5">
      <div class="col-lg-6">
        <h2>{{ $t('entities.ConsultingRoom.Singular') }} {{ name }}</h2>
        <div class="row my-3">
          <div class="col-lg-3">
            <label for="gender">{{ $t('fields.name') }}:</label>
          </div>
          <div class="col-lg-9">
            <b-form-input
              class="myInput"
              :disabled="true"
              v-model="name" />
          </div>
        </div>
        <div class="row my-3">
          <div class="col-lg-3">
            <label for="gender">{{ $t('fields.price') }}:</label>
          </div>
          <div class="col-lg-9">
            <b-form-input
              class="myInput"
              :disabled="true"
              v-model="price" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState, mapMutations } from 'vuex';

export default {
  name: 'ProductTypeViewDetail',
  data() {
    return {
      ready: false
    };
  },
  computed: {
    id() {
      return this.$route.params.id;
    },
    ...mapState('productTypeDetail', ['name', 'price']),
  },
  created() {
    this.setProductTypeId(this.id);
    this.fetchProductType()
      .then(() => {
        this.ready = true;
      });
  },
  methods: {
    ...mapActions({ fetchProductType: 'productTypeDetail/fetchProductType', resetContext: 'productTypeDetail/resetContext' }),
    ...mapMutations({ setProductTypeId: 'productTypeDetail/setProductTypeId' })
  }
};
</script>
<style lang="scss" scoped>
</style>
